import { CollectStatusFilterSkeleton } from "~/components/collect/collect-status-filter-skeleton";
import { ClearFiltersButton } from "~/components/collect/operator/clear-filters-button";
import {
  CollectStatusFilter,
  STATUS_OPTIONS,
  type CollectStatus
} from "~/components/collect/operator/collect-status-filter";

import { type DiscoveryView } from "./discovery-view";

type DiscoveryHeaderProps = {
  view: DiscoveryView;
  statusFilter: CollectStatus;
  counts: Record<CollectStatus, number>;
  onStatusChange: (value: CollectStatus) => void;
  hasActiveFilters: boolean;
  onClearFilters: () => void;
};

export const DiscoveryHeader = ({
  view,
  statusFilter,
  counts,
  onStatusChange,
  hasActiveFilters,
  onClearFilters
}: DiscoveryHeaderProps) => {
  if (view === "loading") {
    return <CollectStatusFilterSkeleton count={STATUS_OPTIONS.length} />;
  }
  if (view === "error" || view === "empty") {
    return null;
  }
  return (
    <div className="flex w-full items-center justify-between gap-4">
      <CollectStatusFilter
        value={statusFilter}
        counts={counts}
        onChange={onStatusChange}
      />
      {hasActiveFilters ? (
        <ClearFiltersButton onClick={onClearFilters} />
      ) : null}
    </div>
  );
};
